// Date templates
export const TABLE_DATE_FORMAT = 'MMM Do YYYY';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const CALENDAR_INPUT_DATE_FORMAT = 'YYYY-MM-DD';
export const LOAN_DATE_FORMAT = 'MMM Do, YYYY';
export const DATE_TIME_FORMAT = 'MMM Do YYYY hh:MM A';

// Phone number templates
export const LANDLINE_PHONE_NUMBER = '+63 99 9999 9999'
